

import React from 'react';
import VideoPlayer from '../../../VideoPlayer';


import { SplashVideoDefaultPlaceholder } from '../../../ImagePlaceholder';
import { useThemeContext } from '../../../../contexts/ThemeContext';






const WithControlsPlayer = (props) => {
  const { video } = props;
  const { source, thumbnailUrl } = video;

  const { primary } = useThemeContext();

  return (
    <>
      {source ?
      <VideoPlayer
        videoUrl={source}
        thumbnailUrl={thumbnailUrl}
        brandingColor={primary} /> :

      <SplashVideoDefaultPlaceholder />}
    </>);

};

export default WithControlsPlayer;